import React, { PureComponent } from 'react';
import { assocPath, path } from 'ramda';
import PropTypes from 'prop-types';

import messages from './filterModalActivities.messages';
import { AccordionCheckbox } from '../../accordionCheckbox';

const labelFieldName = 'name';

export class FilterModalActivities extends PureComponent {
  static propTypes = {
    selectedMarketId: PropTypes.string,
    setFilterDataByFilterName: PropTypes.func.isRequired,
    currentFilter: PropTypes.object.isRequired,
    categoriesData: PropTypes.object.isRequired,
    setTouched: PropTypes.func.isRequired,
  };

  updateFiltersStateInStore = data => this.props.setFilterDataByFilterName(this.props.currentFilter.name, data);

  processChanges = updatedInputsState => {
    this.updateFiltersStateInStore(updatedInputsState);
    this.props.setTouched();
  };

  handleOptionCheckboxClick = optionId => {
    const value = !path([optionId, 'value'], this.props.currentFilter.data);
    const withValue = assocPath([optionId, 'value'], value, {});

    this.processChanges({
      ...this.props.currentFilter.data,
      ...withValue,
    });
  };

  render() {
    return (
      <AccordionCheckbox
        subOptionsMarkedCountMessage={messages.regions}
        allSubOptionsMarkedMessage={messages.allRegions}
        inputsState={this.props.currentFilter.data}
        options={this.props.categoriesData[this.props.selectedMarketId]}
        labelFieldName={labelFieldName}
        onOptionClick={this.handleOptionCheckboxClick}
      />
    );
  }
}
